import svgFont from '@Public/fonts/pressly-icons.svg'
import woffFont from '@Public/fonts/pressly-icons.woff'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  /*
  * This is the global stylesheet that defined shared classes for reuse in
  * submodules.
  */
   
  *, :after, :before {
    box-sizing: border-box;
  }
  
  html, body {
    margin: 0;
    padding: 0;
    font-size: 62.5%;
    font-weight: normal;
    -webkit-text-size-adjust: none;
    -webkit-touch-callout: none;
    -ms-user-select: none;
    overflow-y: overlay;
  }
  
  html, body, input, textarea, table {
    font-family: Roboto, 'Helvetica Neue', -apple-system, BlinkMacSystemFont, Arial, sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  div {
    margin: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    letter-spacing: 0.5px;
    font-weight: 200;
  }
  
  /* IE10/11 */
  article, aside, figure, footer, header, hgroup, main, menu, nav, section {
    display: block;
  }
  
  a {
    text-decoration: none;
    cursor: pointer;
  }

  p {
    margin-top: 0;
  }

  main {
    min-height: 100vh;
  }

  input, textarea {
    font-size: 100%;
  }

  input, textarea, button {
    &:focus {
      outline: none;
    }
  }
  
  /* clears the 'X' for Microsoft */
  input[type=search] {
    &::-ms-clear,
    &::-ms-reveal {  
      display: none;
      width : 0;
      height: 0; }
  }
  
  /* clears the 'X' for Chrome */
  input[type=search] {
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }
  
  hr {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayLighter};
  }
  
  .header {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    font-family: 'Open Sans', sans-serif;
  }

  .header a {
    color: #fff;
  }
  
  .withNavbar {
    padding-top: ${({ theme }) => theme.sizes.navbarHeight};

    & main {
      min-height: calc(100vh - ${({ theme }) => theme.sizes.navbarHeight});
    }
  }
  
  .withNavbars {
    padding-top: calc(${({ theme }) => theme.sizes.navbarHeight} + ${({ theme }) =>
  theme.sizes.collectionsNavHeight});

    & main {
      min-height: calc(100vh - ${({ theme }) => theme.sizes.navbarHeight} - ${({ theme }) =>
  theme.sizes.collectionsNavHeight});
    }
  }
  
  .no-scrollbar::-webkit-scrollbar,
  .no-scrollbar::-webkit-scrollbar-track,
  .no-scrollbar::-webkit-scrollbar-thumb {
    display: none;
  }


  input:-webkit-autofill:active,
  input:-webkit-autofill {
    background: white !important;
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
    -webkit-text-fill-color: #333;
  }

  input:-webkit-autofill:focus {
    background: white !important;
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
    -webkit-text-fill-color: #333;
  }
  
  .email { background-color: ${({ theme }) => theme.colors.email} !important; }
  .twitter { background-color: ${({ theme }) => theme.colors.twitter} !important; }
  .linkedin { background-color: ${({ theme }) => theme.colors.linkedin} !important;}
  .facebook { background-color: ${({ theme }) => theme.colors.facebook} !important; }
  .gplus { background-color: ${({ theme }) => theme.colors.gplus} !important;}
  .rss { background-color: ${({ theme }) => theme.colors.rss} !important; }
  .soundcloud { background-color: ${({ theme }) => theme.colors.soundcloud} !important; }
  .youtube { background-color: ${({ theme }) => theme.colors.youtube} !important; }
  .vimeo { background-color: ${({ theme }) => theme.colors.vimeo} !important; }
  .instagram { background-color: ${({ theme }) => theme.colors.instagram} !important; }
  .pinterest { background-color: ${({ theme }) => theme.colors.pinterest} !important; }
  .pressly { background-color: ${({ theme }) => theme.colors.pressly} !important; }
  .slack { background-color: ${({ theme }) => theme.colors.slack} !important; }
  
  /*Accessibility related styles*/
  .hidden-elements {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .hidden-elements.focusable:active,
  .hidden-elements.focusable:focus {
    clip: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    position: static;
  }
  .btn-icon-wrapper{
    font-family: Roboto, 'Helvetica Neue', -apple-system, BlinkMacSystemFont, Arial, sans-serif;
    background: none;
    border: none;
    &:hover {
      cursor: pointer;
    }
    &:focus {
      outline: 5px auto -webkit-focus-ring-color;
    }
  }

   @font-face {
     font-family: 'pressly-icons';
     src: url('${woffFont}') format('woff'), url('${svgFont}') format('svg');
     src: url('${woffFont}.eot'); /* IE9 Compat Modes */
     src: url('${woffFont}.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
          url('${woffFont}') format('woff'), /* Pretty Modern Browsers */
          url('${svgFont}#${woffFont}') format('svg'); /* Legacy iOS */
  }
  
  // ToDo: Find a better way to customize popover
  .react-tiny-popover-container {
    overflow: visible !important;
    z-index: 111;
  }
  
  // Adds a padding to Draft.js ol, so it matches the default padding of the ul
  .public-DraftStyleDefault-ol {
    padding-inline-start: 8px;
  }
`

export default GlobalStyle
